/**
 * Cruise line / sub-brand logo URLs from public/images (copied from iOS Assets).
 * Asset names match catalog labels exactly, same as CruiseLineLogoView on iOS.
 *
 * Filenames keep spaces (e.g. "Azamara Cruises.png"). We encode path segments
 * so static hosting resolves them reliably.
 */

const LOGOS_BASE = '/images/cruise-logos';
const SUBBRANDS_BASE = '/images/cruise-subbrands';

function logoPath(base: string, name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) return null;
  // encodeURIComponent turns spaces into %20; leave the .png extension unencoded.
  return `${base}/${encodeURIComponent(trimmed)}.png`;
}

export function cruiseLineLogoUrl(cruiseLine: string): string | null {
  return logoPath(LOGOS_BASE, cruiseLine);
}

export function cruiseSubBrandLogoUrl(label: string): string | null {
  return logoPath(SUBBRANDS_BASE, label);
}
